'use client';

import { Activity } from 'lucide-react';
import { SynthesisCard } from './synthesis-card';
import { useObeyaProjectData } from './use-obeya-project-data';

/**
 * Card data contract (the relocatable shape): `strategy` + `entityId` are
 * PROPS the mount hands down — the capability + the entity it resolved. The
 * Ask overlay passes them (renderer-slot-card.tsx), so the card runs
 * `fetch(strategy, { project_id: entityId })` for THAT project instead of the
 * ambient mode1 selection. When a prop is absent the card falls back to its
 * mode1 defaults — canonical `project_health` + the selection store — so
 * mode1 is unchanged. Same shape `SynthesisCard` already honours.
 */
export function ObeyaHealthCard({
  strategy,
  entityId,
}: {
  strategy?: string;
  entityId?: string;
}) {
  const { projectId } = useObeyaProjectData();
  return (
    <SynthesisCard
      title="Project Health"
      strategy={strategy ?? 'project_health'}
      pinStrategyName="health_synthesis"
      entitySid={entityId ?? projectId}
      entityParam="project_id"
      emptyLabel="Select a project"
      Icon={Activity}
      iconColor="text-blue-400"
    />
  );
}
